import React from "react";
import "./style.css";
import ukImage from "../../assets/uk.webp";
import Particles from "../Particles/Particles";
import university1 from "../../assets/university-logos/uk/Conventry_University.webp";
import university2 from "../../assets/university-logos/uk/Malvern_International.webp";
import university3 from "../../assets/university-logos/uk/Univerisity_of_the_West_of_Scotland.webp";
import university4 from "../../assets/university-logos/uk/University_of_Birmingham.webp";
import university5 from "../../assets/university-logos/uk/University_of_East_London.webp";
import university6 from "../../assets/university-logos/uk/University_of_Roehampton.webp";
import university7 from "../../assets/university-logos/uk/University_of_Sunderland.webp";
import university8 from "../../assets/university-logos/uk/London_Metropolitan_University.webp";
import university9 from "../../assets/university-logos/uk/York_John_University.webp";

const universityList = [
  { id: Math.random(), image: university1 },
  { id: Math.random(), image: university2 },
  { id: Math.random(), image: university3 },
  { id: Math.random(), image: university4 },
  { id: Math.random(), image: university5 },
  { id: Math.random(), image: university6 },
  { id: Math.random(), image: university7 },
  { id: Math.random(), image: university8 },
  { id: Math.random(), image: university9 },
];

const UK = () => {
  return (
    <>
      <Particles
        title="Study in UK"
        subTitle="Explore Opportunities, Courses, and Culture"
        image={ukImage}
      />
      <div className="short-description container">
        <h1 className="text-left">Study in UK</h1>
        <p className="text-justify">
          The United Kingdom is one of the most sought-after destinations for
          international students, offering a rich blend of world-class
          education, cultural diversity, and historic legacy. With globally
          recognized universities like Oxford, Cambridge, and Imperial College
          London, students gain access to top-tier teaching, cutting-edge
          research, and industry connections. UK degrees are shorter in duration
          – typically 3 years for undergraduate and 1 year for postgraduate –
          saving both time and money. The UK also offers a Graduate Route visa,
          allowing international students to stay and work for up to 2 years
          after completing their degree (3 years for PhD graduates). From
          bustling cities like London and Manchester to peaceful towns like Bath
          and Durham, the UK offers a unique student lifestyle and strong
          support networks. Whether you're looking to study business,
          engineering, healthcare, or the arts, the UK has something for
          everyone. Let us help you choose the right course, university, and
          guide you through every step – from application to visa to
          accommodation.
          <br /> <br />
          At <strong>Educraft Education Network</strong>, we go beyond just
          applications — we help you find the right course, the right
          university, and the right future. Our expert counselors work closely
          with you to understand your academic background, interests, and career
          goals. Whether you’re unsure which course to choose or which city
          suits you best, we provide personalized guidance to match you with
          colleges and universities that align with your ambitions and budget.
          From university selection and document preparation to SOP writing,
          visa processing, and pre-departure sessions — we support you at every
          stage. With a strong network of trusted UK institutions and up-to-date
          knowledge of admission trends, Educraft ensures your study abroad
          journey is smooth, informed, and successful.
        </p>
      </div>

      <div className="why-study container">
        <h1 className="text-left">Why study in UK? </h1>
        <p className="text-left">
          The United Kingdom has consistently attracted students from around the
          world. Here are key reasons why it should be your destination for
          higher education:
        </p>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="first-tab"
              data-bs-toggle="tab"
              data-bs-target="#first"
              type="button"
              role="tab"
              aria-controls="first"
              aria-selected="true"
            >
              Academic Brilliance
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="second-tab"
              data-bs-toggle="tab"
              data-bs-target="#second"
              type="button"
              role="tab"
              aria-controls="second"
              aria-selected="false"
            >
              Study Flexibility
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="third-tab"
              data-bs-toggle="tab"
              data-bs-target="#third"
              type="button"
              role="tab"
              aria-controls="third"
              aria-selected="false"
            >
              Globally Recognized
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="fourth-tab"
              data-bs-toggle="tab"
              data-bs-target="#fourth"
              type="button"
              role="tab"
              aria-controls="fourth"
              aria-selected="false"
            >
              International Diversity
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane show active"
            id="first"
            role="tabpanel"
            aria-labelledby="first-tab"
          >
            <h6>
              UK universities are globally renowned for their high academic
              standards, pioneering research, and commitment to quality
              education. Institutions such as the University of Oxford,
              Cambridge, and Imperial College London consistently rank among the
              world’s best. With access to state-of-the-art facilities and
              expert faculty, students are challenged to think critically,
              innovate, and excel in their chosen fields.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="second"
            role="tabpanel"
            aria-labelledby="second-tab"
          >
            <h6>
              The UK offers an extensive selection of courses across various
              disciplines — from traditional fields like medicine, law, and
              engineering to emerging areas such as data science, artificial
              intelligence, and sustainability. Programs are taught in English,
              and many universities allow flexible combinations of subjects,
              enabling students to design a study path that aligns with their
              personal interests and long-term career goals.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="third"
            role="tabpanel"
            aria-labelledby="third-tab"
          >
            <h6>
              A degree from a UK university carries international prestige and
              is recognized by employers, academic institutions, and governments
              worldwide. UK qualifications emphasize both theoretical knowledge
              and practical application, giving graduates a competitive
              advantage in the global job market. Whether you plan to work
              abroad or continue your studies, a UK degree opens doors to
              international success.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="fourth"
            role="tabpanel"
            aria-labelledby="fourth-tab"
          >
            <h6>
              Studying in the UK means immersing yourself in a vibrant,
              multicultural environment. With students from all over the world,
              you’ll gain not only academic knowledge but also global
              perspectives and intercultural skills. From historical landmarks
              and diverse cuisines to festivals and student societies, the UK
              offers a culturally enriching experience that broadens your
              worldview and helps you build lifelong connections.
            </h6>
          </div>
        </div>
      </div>

      <div className="university-partners container">
        <h1 className="text-left">Our University Partner in UK</h1>
        <div className="row">
          {universityList?.map((list) => (
            <div key={list.id} className="col-6 col-md-4 col-lg-3 p-2">
              <div className="partner-box">
                <img src={list.image} alt="university logo" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default UK;
